// @flow strict
import * as React from 'react';

/**
 * @ignore
 */
export const TriangleDown = (): React.Element<*> => (
  <path d="M15.933 4.745c-0.089-0.148-0.248-0.245-0.43-0.245-0 0-0 0-0 0h-11c-0.276 0-0.499 0.224-0.499 0.5 0 0.088 0.023 0.171 0.063 0.243l-0.001-0.003 5.5 10c0.087 0.156 0.25 0.259 0.438 0.259s0.351-0.103 0.437-0.256l0.001-0.003 5.5-10c0.039-0.069 0.062-0.152 0.062-0.241 0-0.094-0.026-0.182-0.071-0.257l0.001 0.002z"></path>
);
